( function () {
document.addEventListener("DOMContentLoaded", () => {
  const desc = document.querySelector(".hero__desc");
  const descContainer = document.querySelector(".hero__desc-container");
  if (!desc || !descContainer) return;

  const lineHeight = parseFloat(getComputedStyle(desc).lineHeight);
  const maxLines = 2;
  const maxHeight = lineHeight * maxLines;

  // Only add toggle if text overflows
  if (desc.scrollHeight > maxHeight * 1.1) {
    desc.classList.add("truncated");
    descContainer.classList.add("truncated");

    // Create the toggle button
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "hero__desc-toggle hero__desc-toggle--visible";
    btn.innerHTML = `
      <i class="hero__desc-toggle--more">Read More</i>
      <i class="hero__desc-toggle--less">Read Less</i>
    `;

    // Insert button after description
    desc.insertAdjacentElement("afterend", btn);

    btn.addEventListener("click", () => {
      const expanded = desc.classList.toggle("expanded");
      desc.classList.toggle("truncated", !expanded);
      desc.classList.toggle("expanded", expanded);
      descContainer.classList.toggle("truncated", !expanded);
      descContainer.classList.toggle("expanded", expanded);
    });
  }
});
} )();